import axios from 'axios';
import qs from 'qs';

import { queryClient } from '../helpers/query-client.ts';

const generateRandomId = () => Math.floor((1 + Math.random()) * 0x1000000).toString(16);

export const sessionId = generateRandomId();

let isRefreshing = false;
let refreshPromise: Promise<void> | null = null;

export const apiClient = axios.create({
  responseType: 'json',
  baseURL: import.meta.env.VITE_API_URL,
  withCredentials: true,
  paramsSerializer: {
    serialize: (params) => qs.stringify(params),
  },
});

const refreshClient = axios.create({
  responseType: 'json',
  baseURL: import.meta.env.VITE_API_URL,
  withCredentials: true,
});

apiClient.interceptors.request.use((config) => {
  config.headers.set('Cache-Control', 'no-cache', true);
  config.headers.set('x-sessionId', sessionId);
  config.headers.set('x-requestId', generateRandomId());

  return config;
});

refreshClient.interceptors.request.use((config) => {
  config.headers.set('Cache-Control', 'no-cache', true);
  config.headers.set('x-sessionId', sessionId);
  config.headers.set('x-requestId', generateRandomId());

  return config;
});

apiClient.interceptors.response.use(
  (response) => {
    return response.data;
  },
  async function (error) {
    const originalRequest = error.config;

    if (!error.response) {
      return Promise.reject(error);
    }

    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      if (!isRefreshing) {
        isRefreshing = true;

        refreshPromise = refreshClient
          .post('/v1/auth/refresh')
          .then(() => {})
          .finally(() => {
            isRefreshing = false;
            refreshPromise = null;
          });
      }

      try {
        await refreshPromise;
        return apiClient(originalRequest);
      } catch (err) {
        return Promise.reject(err);
      }
    }

    return Promise.reject(error);
  },
);

refreshClient.interceptors.response.use(
  (response) => response,
  async function (error) {
    queryClient.resetQueries();

    return Promise.reject(error);
  },
);
